import ObjetoConId from "../tipos/objetoConId";

const FIELD_NOMBRE = "nombre";

class Variable extends ObjetoConId {
  constructor(obj) {
    super(obj.id);
    this.idStr = obj.idStr;
    this.nombre = obj.nombre;
    this.unidad = obj.unidad;
    this.descripVariab = obj.descripVariab;
    this.tipoIngreso = obj.tipoIngreso;
    this.nDecim = obj.nDecim;
    this.nDigitosAlImprimir = obj.nDigitosAlImprimir;
    this.entera = obj.entera;
    this.periodicidad = obj.periodicidad;
    this.tamanioColumnaCodigo = obj.tamanioColumnaCodigo;
    this.periodoDeRegistro = obj.periodoDeRegistro;
    this.tipoDeMedicion = obj.tipoDeMedicion;
    this.grupoVista = obj.grupoVista;
  }

  getNombreYUnidad() {
    return this.unidad ? this.nombre + " (" + this.unidad + ")" : this.nombre;
  }

  getNombre(incluirUnidad) {
    return incluirUnidad ? this.getNombreYUnidad() : this.nombre;
  }
}

function crearVariable(obj) {
  return new Variable(obj);
}

export { Variable as default, crearVariable, FIELD_NOMBRE };
